import { deepCopy, getCookie, setCookie, isEmptyObject, setPageTitle, timestampToTime } from "@/utils"
import { mapGetters } from 'vuex'
import { checkTempPaper, getServerTime, savePaper, saveTemp, updatePaperRecord } from '@api'

export default {
  computed: {
    ...mapGetters([
      'siteData',
      'visibleCalc',
      'commonInfo',
      'quesTypeShowMap',
      'quesShowList',
      'userAnsMap',
      'submitData',
      'questions',
      'currentQuestion',
      'currentQuestionType',
      'currentQuestionIndex'
    ]),
    preDisabled() {
      return (parseInt(this.currentQuestionType) === 0 && parseInt(this.currentQuestionIndex) === 0)
    },
    nextDisabled() {
      let lastQuesType = this.questions.length - 1
      return (parseInt(this.currentQuestionType) === lastQuesType && parseInt(this.currentQuestionIndex) === this.questions[lastQuesType].list.length - 1)
    }
  },
  created() {
    let that = this
    this.timer = setInterval(async () => {
      let examInfo = that.isNotAnswer()
      if (!examInfo.flag) {
        let params = await that.saveParams()
        saveTemp(params)
      }
  }, 180000)

  },
  methods: {
    async initExam() {
      if (!this.paperRedo) {
        await this.checkTempSave()
      }
      await this.getCurrentSiteCourse()
      await this.getPaperInformation()

      let isHaveSubjective = Object.keys(this.userAnsMap).some(questionID => this.userAnsMap[questionID].quesTypeID === 4 || this.userAnsMap[questionID].quesTypeID === 5);
      this.isHaveSubjective = isHaveSubjective && this.commonInfo.memberScoring;
      //初始化考试时间倒计时
      this.endTimes = this.commonInfo.lastTime < 0 ? 0 : this.commonInfo.lastTime

      //获取计时方式
      this.timerMode = this.commonInfo.timerMode
      this.$refs.countDown.setTime(this.commonInfo.timerMode)

      // 临时保存
      let params = await this.saveParams()
      saveTemp(params)

      //点击答题区域外失去焦点
      /*document.addEventListener('click',(e) => {
        let $el = document.getElementById('answerArea')
        if($el !== null && $el && !$el.contains(e.target)) {
          $('#answerArea').blur()
        }
      })

      function doKey(e){
        var ev = e || window.event;//获取event对象
        var obj = ev.target || ev.srcElement;//获取事件源
        var t = obj.type || obj.getAttribute('type');//获取事件源类型
        if(ev.keyCode == 8 && (t == "radio" || t == "checkbox")){
          return false;
        }
      }
      //禁止后退键 作用于Firefox、Opera
      document.onkeypress=doKey;
      //禁止后退键  作用于IE、Chrome
      document.onkeydown=doKey;*/
    },
    //  获取查看解析数据
    quesAnalyFun(bizID) {
      let params = {
        flag: this.flag,
        bizID: bizID
      }
      this.$store.dispatch('getQuesAnaly', params).then(res => {
        res.bizID = bizID
        res.commonInfo.bizID = bizID
        res.userAnsMap = this.userAnsMapFormat(this.questionsMap)
        let param = res
        updatePaperRecord(param).then(() => {
          // this.bizID = res.bizID
          this.visibleSub = false
          this.routeToAnalysis()
        }).catch(err => {
          this.$message.error(err.msg)
        })
      })
    },
    //检测是否有临时保存
   async checkTempSave() {
      let params = {
        siteCourseID: this.siteCourseID,
        flag: this.flag,
        userID: this.uid,
        chapterID: this.chapterID
      }
      // 查询是否有临时保存试题
     await checkTempPaper(params).then(res => {
        const { flag } = this.$route.params
        if (res.length > 0) {
          const tempData = res[0]
          const { includeTempButAbandon } = this.$route.query
          if (includeTempButAbandon && includeTempButAbandon === '1') {
            this.temp = 1
            this.spendTime = 0
          } else {
            this.bizID = tempData.bizID
            this.temp = 2
            this.spendTime = tempData.spendTime
          }
          return this.$router.replace({
            path: `/${flag}/doExamChapter`,
            query: {
              siteCourseID: this.siteCourseID,
              courseID: this.courseID,
              bizID: this.bizID,
              spendTime: this.spendTime,
              temp: this.temp,
              chapterID: this.chapterID
            }
          })
        }
      })
    },
    //获取当前课程信息
    async getCurrentSiteCourse() {
      if (isEmptyObject(this.siteData)) {
        let params = {
          flag: this.flag,
          siteCourseID: this.siteCourseID,
          majorID: this.majorID
        }
        await this.$store.dispatch('getCurrentSiteInfo', params).then(res => {
          this.courseName = res.currentCourse.courseName
        }).catch(err => {
          this.$message.error(err.msg)
        })
      } else {
        this.courseName = this.siteData.currentCourse.courseName
      }
      document.title = setPageTitle(this.courseName)
    },
    //获取试卷四大对象信息
    async getPaperInformation() {
      if (this.paperRedo && this.paperRedo === 1) {
        let params = {
          flag: this.flag,
          siteCourseID: this.siteCourseID,
          bizID: this.bizID,
          userID: this.uid,
          contestTimeLimit: 60
        }
        await this.$store.dispatch('getAllInformationRedo', params).then(() => {
          this.$nextTick(() => {
            this.loadingInstance.close()
          })
          //初始化当前题目，默认为第一大题第一小题
          this.$store.dispatch('setCurQues', this.questions[this.currentQuestionType].list[this.currentQuestionIndex])
        }).catch(err => {
          alert(err.msg)
          if(err.errorCode === '-1') this.$router.push({ name: 'examSystem', query: { siteCourseID: this.siteCourseID, courseID: this.courseID } })
        })
      } else if(this.temp==2) {
        let params = {
          flag: this.flag,
          siteCourseID: this.siteCourseID,
          temp: this.temp,
          userID: this.uid,
          bizID: this.bizID,
          spendTime: this.spendTime,
      }
      await this.$store.dispatch('getAllInformation', params).then(() => {
        this.$nextTick(() => {
          this.loadingInstance.close()
        })
          //初始化当前题目，默认为第一大题第一小题
          this.$store.dispatch('setCurQues', this.questions[0].list[0])
          this.isVisibleQueDetail = true
      }).catch(err => {
          alert(err.msg)
          if (err.errorCode === '-1') this.$router.push({
              name: 'examSystem',
              query: {siteCourseID: this.siteCourseID, courseID: this.courseID}
          })
      })
      }else {
        let params = {
          flag: this.flag,
          siteCourseID: this.siteCourseID,
          courseID: this.courseID,
          chapterID: this.chapterID,
          strategy: this.strategy,
          userID: this.uid,
          exerciseTime: parseInt(getCookie('exerciseTime'))
        }
        await this.$store.dispatch('getAllInformationChapter', params).then(() => {
          this.$nextTick(() => {
            this.loadingInstance.close()
          })
          //初始化当前题目，默认为第一大题第一小题
          this.$store.dispatch('setCurQues', this.questions[this.currentQuestionType].list[this.currentQuestionIndex])
        }).catch(err => {
          alert(err.msg)
          if(err.errorCode === '-1') this.$router.push({ name: 'examSystem', query: { siteCourseID: this.siteCourseID, courseID: this.courseID } })
        })
      }
    },
    //标记按钮
    markToggleFn() {
      this.$store.dispatch('setIsMark')
    },
    //倒计时结束自动交卷
    async endToSubmit() {
      const that = this
      this.commitStatus = true
      const quesTypeID = this.currentQuestion.quesTypeID
      if (quesTypeID === 4 || quesTypeID === 5) {
        let hasChildDom = this.$refs['hasChildQuestion']
        let withoutChildDom = this.$refs['withoutChildQuestion']
        if (hasChildDom) {
          await hasChildDom.setCurrentSmallContent(this.currentQuestion)
        } else if (withoutChildDom) {
          await withoutChildDom.setCurrentSmallContent(this.currentQuestion)
        }
      }
      // 交卷方法
      let examInfo = this.isNotAnswer()
      let params = await this.saveParams()
      await savePaper(params).then(res => {
        this.bizID = res.bizID
        clearInterval(this.timer)
        this.commitStatus = false
      }).catch(err => {
        this.commitStatus = false
        this.$message.error(err.msg)
      })
      if (!examInfo.flag) {
        this.commitStatus = false
        this.endExamFlag = true
      } else {
        this.commitStatus = false
        this.$alert('倒计时时间到，您并未作答！', '', {
          confirmButtonText: '确定',
          callback: () => {
            that.$router.push({
              name: 'examSystem',
              query: {
                siteCourseID: this.siteCourseID,
                courseID: this.courseID
              }
            })
          }
        })
      }
    },
    //点击交卷按钮
    async handOverFn() {
      // 临时保存
      let examInfo = this.isNotAnswer()
      if (!examInfo.flag) {
        let params = await this.saveParams()
        saveTemp(params)
      }
      const quesTypeID = this.currentQuestion.quesTypeID
      if (quesTypeID === 4 || quesTypeID === 5) {
        let hasChildDom = this.$refs['hasChildQuestion']
        let withoutChildDom = this.$refs['withoutChildQuestion']
        if (hasChildDom) {
          await hasChildDom.setCurrentSmallContent(this.currentQuestion)
        } else if (withoutChildDom) {
          await withoutChildDom.setCurrentSmallContent(this.currentQuestion)
        }
      }
      if(this.currentQuestion.quesTypeID === 2 && this.currentQuestion.userAnswer.length === 1) {
        this.multiStatus = true
        this.visibleAlert = true
        return
      }
      this.visibleAlert = true
    },
    //结束考试
    async endToSave() {
      if(this.commitStatus){
        alert('提交中，请勿重复点击~')
        return
      }
      // 交卷方法
      this.commitStatus = true
      let examInfo = this.isNotAnswer()
      if (!examInfo.flag) {
        let params = await this.saveParams()
        savePaper(params).then(res => {
          this.bizID = res.bizID
          this.endExamFlag = true
          this.endTimes = 0
          clearInterval(this.timer)
          this.commitStatus = false
          this.visibleAlert = false
        }).catch(err => {
          this.commitStatus = false
          this.$message.error(err.msg)
        })
      } else {
        this.commitStatus = false
      }
    },
    //保存试卷参数
    async saveParams() {  //  提交四大对象
      let quesTypeShowMap = JSON.parse(JSON.stringify(this.quesTypeShowMap))
      for(let i in quesTypeShowMap){
        if(quesTypeShowMap[i].list){
          delete quesTypeShowMap[i].list
        }
      }
      let userAnswerParams = {
        userAnsMap: {},
        quesShowList: this.quesShowList,
        quesTypeShowMap: quesTypeShowMap,
        commonInfo: {}
      }
      let otherData = { ...this.submitData }

      let curTime = await getServerTime(()=>{}).catch(e=>{})
      this.spendTimeTotle = this.commonInfo.timerMode == 2 ? parseInt(this.endTimes) : parseInt(this.exerciseTime) * 60 - this.endTimes
      let commonInfoOther = {
        createTime: timestampToTime(curTime),
        userID: this.uid,
        userName: getCookie('username'),
        spendTime: this.spendTimeTotle,
        paperScore: otherData.paperScore,
        allQuesNum: otherData.allQuesNum,
        allChildQuesNum: otherData.allChildQuesNum,
        quesTypeResultList: otherData.quesTypeResultList,
        siteCourseID: this.siteCourseID,
        lastTime: this.endTimes
      }
      let exerciseName = getCookie('exerciseName')
      let exerciseTime = parseInt(getCookie('exerciseTime'))
      let obj = {
        examName: exerciseName,
        contestTimeLimit: exerciseTime
      }
      let commonInfoCopy
      if (exerciseName !== undefined) {
        commonInfoCopy = { ...this.commonInfo, ...commonInfoOther, ...obj }
      } else {
        commonInfoCopy = { ...this.commonInfo, ...commonInfoOther }
      }
      this.$store.commit('SET_COMMON_INFO', commonInfoCopy)

      userAnswerParams.commonInfo = commonInfoCopy
      userAnswerParams.userAnsMap = this.userAnsMapFormat(this.questions)
      return userAnswerParams
    },
    //用户答案对象格式化，将questions中的题目重新整理成提交的userAnsMap对象
    userAnsMapFormat(obj) {
      let result = {}
      let copyQuestions = deepCopy(obj)
      copyQuestions.forEach(quesType => {
        quesType.list.forEach(ques => {
          if (ques.quesTypeID === 2) {
            //处理临时保存返回的数据为字符串不是数组的情况，则不需要转字符串
            let flag = Array.isArray(ques.userAnswer)
            if(flag)ques.userAnswer = ques.userAnswer.sort().join('')
          }
          let smallContent = ques.smallContent
          if (smallContent && smallContent.length) {
            smallContent.forEach(smallQues => {
              result[smallQues.questionID] = smallQues
              if (smallQues.quesTypeID === 2 && smallQues.userAnswer !== null) {
                //处理临时保存返回的数据为字符串不是数组的情况，则不需要转字符串,此种题型为大题套小题且小题为不定项选择题时，有临时保存回显时会出现
                let flag = Array.isArray(smallQues.userAnswer)
                if(flag)smallQues.userAnswer = smallQues.userAnswer.sort().join('')
              }
            })
            delete (ques.smallContent)
          }
          result[ques.questionID] = ques
        })
      })

      return result
    },
    //确定是否没有答题
    isNotAnswer() {
      let allQuestions = []
      Object.values(this.questions).forEach((item, index) => {
        allQuestions[index] = []
        allQuestions[index] = [...item.list]
      })
      allQuestions = Array.prototype.concat([], ...allQuestions)
      this.alertWindow.allQuestions = allQuestions
      this.alertWindow.courseName = this.commonInfo.examName || getCookie('courseName') || getCookie('exerciseName')
      let flag = allQuestions.every(item => {
        //  大题套小题
        if (item.smallContent) {
          let res = item.smallContent.some(smallQues => {
            let hasAnswer = false
            if (smallQues.attAnswer) {
              // hasAnswer = smallQues.tempAnswer === 'true'
              hasAnswer = smallQues.isAnswer === 1
            } else {
              hasAnswer = smallQues.userAnswer && smallQues.userAnswer.length > 0
            }
            return hasAnswer
          })
          return !res
        } else {
          if (item.userAnswer instanceof Array) {  //  多选题
            return item.userAnswer.length === 0
          } else {
            //  其他简单题型
            let hasAnswer = false
            if (item.attAnswer) {
              hasAnswer = item.tempAnswer === 'true'
            } else {
              hasAnswer = item.userAnswer && item.userAnswer.length > 0
            }
            return !hasAnswer
          }
        }
      })
      return {
        allQuestions,
        flag
      }
    },

    //结束考试后，查看考试解析
    viewResults() {
      this.endExamFlag = false
      clearInterval(this.timer)
      this.routeToAnalysis()
    },
    //给主观题打分
    async subjectiveQuestionsStore() {
      // await this.$store.dispatch('getQuesAnaly', { flag: this.flag, bizID: this.bizID }).then(() => {
      //   this.questionsMap = deepCopy(this.questions)
      // })
      this.endExamFlag = false
      // this.visibleSub = true
      clearInterval(this.timer)
      const { flag } = this.$route.params
      const { routerSource, routerSourcePages } = this.$route.query
      const { majorTag } = this.$categoryInfo
      let ReportUrl = '//member.chinaacc.com/vqzs/report/common?identity=-2&isExamina=1&jkFlag=' + majorTag + '&siteCourseID='
        + this.siteCourseID + '&courseID=' + this.courseID + '&paperViewID=-1&bizID=' + this.bizID+ '&flag=' + flag;
      if (routerSource) {
        ReportUrl = ReportUrl + '&routerSource=' + routerSource;
        if (routerSourcePages) {
          ReportUrl = ReportUrl + '&routerSourcePages=' + routerSourcePages;
        }
      }
      window.location.href = `//member.chinaacc.com/vqzs/scoring/common?bizID=${this.bizID}&gotoUrl=${encodeURIComponent(ReportUrl)}`;
    },
    //计算器切换
    runCalc() {
      // this.$store.dispatch('toggleCalc')
      let flag = document.getElementById('my-calculator').style.display === 'none'
      if (flag) {
        document.getElementById('my-calculator').style.display = 'block'
      } else {
        document.getElementById('my-calculator').style.display = 'none'
      }
    },
    //切换题目(上一页下一页)
    async buttonChange(quesType, quesIndex, oldQues) {
      const quesTypeID = oldQues.quesTypeID
      if (quesTypeID === 4 || quesTypeID === 5) {
        let hasChildDom = this.$refs['hasChildQuestion']
        let withoutChildDom = this.$refs['withoutChildQuestion']
        if (hasChildDom) {
          await hasChildDom.setCurrentSmallContent(oldQues)
        } else if (withoutChildDom) {
          await withoutChildDom.setCurrentSmallContent(oldQues)
        }
      }
      await this.$store.dispatch('setCurQuesType', quesType)
      await this.$store.dispatch('setCurQuesIndex', quesIndex)
      await this.$store.dispatch('setCurQues', this.questions[quesType].list[quesIndex])
    },
    //  切换题目(答题卡)
    async changeByQueList(quesType, quesIndex, oldQues) {
      if(this.currentQuestion.quesTypeID === 2 && this.currentQuestion.userAnswer.length === 1) {
        this.multiStatus = true
        this.visibleAlert = true
        return
      }
      this.buttonChange(quesType, quesIndex, oldQues)
    },
    //主观题评分提交
    async submitSub() {
      let examInfo = this.isNotAnswer()
      if (!examInfo.flag) {
        this.quesAnalyFun(this.bizID)
      }
    },
    //主观题弹框关闭
    closeSubjective() {
      this.visibleSub = false
      this.routeToAnalysis()
    },
    //解析页跳转
    routeToAnalysis() {
      const { flag } = this.$route.params
      const { routerSource, routerSourcePages } = this.$route.query
      const { majorTag } = this.$categoryInfo
      let ReportUrl = '//member.chinaacc.com/vqzs/report/common?identity=-2&isExamina=1&jkFlag=' + majorTag + '&siteCourseID='
        + this.siteCourseID + '&courseID=' + this.courseID + '&paperViewID=-1&bizID=' + this.bizID+ '&flag=' + flag;
      if (routerSource) {
        ReportUrl = ReportUrl + '&routerSource=' + routerSource;
        if (routerSourcePages) {
          ReportUrl = ReportUrl + '&routerSourcePages=' + routerSourcePages;
        }
      }
      window.location.href = ReportUrl;
    },
    //页签title
    timeFilter(value) {
      if(value){
        let numToStr = number => (number > 9 ? number.toString() : '0' + number)
        let hr = parseInt((value / 60 / 60 % 24).toString())
        let min = parseInt((value / 60 % 60).toString())
        let sec = parseInt((value % 60).toString())
        if(this.timerMode == 2){
          return `中级会计职称全国统一考试`
        }else {
          return `本试卷将在${numToStr(hr)}小时${numToStr(min)}分${numToStr(sec)}秒后自动提交!`
        }
      }else{
        return '本试卷将在00小时00分00秒后自动提交!'
      }
    },
    changeQues(type) {
      let newQuesType = this.currentQuestionType, newQuesIndex = this.currentQuestionIndex
      switch (type) {
        case 'prev':
          if(this.currentQuestion.quesTypeID === 2 && this.currentQuestion.userAnswer.length === 1) {
            this.multiStatus = true
            this.visibleAlert = true
            return
          }
          if (parseInt(this.currentQuestionIndex) === 0) {
            if (newQuesType > 0) {
              newQuesType--
              newQuesIndex = this.questions[newQuesType].list.length - 1
            }
          } else {
            newQuesIndex--
          }
          break
        case 'next':
          if(this.currentQuestion.quesTypeID === 2 && this.currentQuestion.userAnswer.length === 1) {
            this.multiStatus = true
            this.visibleAlert = true
            return
          }
          //如果当前小题的序号 = 该大题中最后一个小题序号，则转到下一个大题中
          if (parseInt(this.currentQuestionIndex) === this.questions[this.currentQuestionType].list.length - 1) {
            if (this.questions[this.currentQuestionType + 1]) {
              newQuesIndex = 0
              newQuesType++
            }
          } else {
            newQuesIndex++
          }
          break
      }
      this.buttonChange(newQuesType, newQuesIndex, this.currentQuestion)
    },
    // 答完大题blur更新做题参数
    async setCurrentSmallContentFn() {
      const quesTypeID = this.currentQuestion.quesTypeID
      if (quesTypeID === 4 || quesTypeID === 5) {
        let hasChildDom = this.$refs['hasChildQuestion']
        let withoutChildDom = this.$refs['withoutChildQuestion']
        if (hasChildDom) {
          await hasChildDom.setCurrentSmallContent(this.currentQuestion)
        } else if (withoutChildDom) {
          await withoutChildDom.setCurrentSmallContent(this.currentQuestion)
        }
      }
    }
  }
}
